import cn from 'classnames';
import * as S from './PreChatForm.styles'
import '../../b1.css'
import React, { useState, useRef, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, TextField } from '@material-ui/core'
import { AttachFile as AttachFileIcon, Send as SendIcon, Remove as RemoveIcon } from '@mui/icons-material'
import DefaultAvatar from 'images/widget/user-default.png';
import EndChatIcon from 'images/widget/end-chat.svg';
import { WidgetRect, WidgetCircular } from 'icons';
import { setNewMessageApper } from 'redux_toolkit/reducers/partner/widget/widgetSlice';


export const PreChatForm = ({
  chatConfig
}) => {
  const dispatch = useDispatch();
  const { currentPartner } = useSelector(({ currentPartner })=> currentPartner);
  const { conversation } = useSelector(({ widget }) => widget);
  const chatConfigState = useSelector(({ chat }) => chat.config);
  chatConfig = chatConfig? chatConfig : chatConfigState;

  const scrolledView = useRef(null)
  const [message, setMessage] = useState('');

  const classnames = useMemo(() => ({
    squared: chatConfig.widgetType === 'bar',
    circular: chatConfig.widgetType === 'circular',
  }) , [chatConfig.widgetType]);

  const textColors = useMemo(() => ({
    agent: chatConfig.agentTextColor,
    visitor: chatConfig.visitorTextColor,
    bot: chatConfig.botTextColor
  }), [chatConfig]);

  const bgColors = useMemo(() => ({
    agent: chatConfig.messagesBackgroundColors.our,
    visitor: chatConfig.messagesBackgroundColors.client,
    bot: 'transparent'
  }), [chatConfig])

  const mobileWigetClassname = useMemo(() => chatConfig.windowSize === 'overlay' ? 'overlay' : 'popout', [chatConfig.windowSize])
  
  const addNewMessage = () => {
    dispatch(setNewMessageApper({
      type: 'visitor',
      date: `${new Date().getHours()}:${new Date().getMinutes()}`,
      text: message
    }))
    setTimeout(() => {
      scrolledView.current.scroll({ behavior: 'smooth', top: scrolledView.current.scrollHeight })
      setMessage('')
    }, 0);
  }



  const gradients = {
    'linear-gradient': (deg, color1, color2) => `linear-gradient(${deg}deg, ${color1}, ${color2})`,
    'radial-gradient': (deg, color1, color2) => `radial-gradient(${color1}, ${color2})`,
    'conic-gradient': (deg, color1, color2) => `conic-gradient(from ${deg}deg, ${color1} 0deg, ${color2} 360deg)`,
    'midline-gradient': (deg, color1, color2) => `linear-gradient(${deg - 90}deg, ${color1}, ${color2}, ${color1})`,
  };

  document.documentElement.style.setProperty('--tpc', chatConfig.textareaPlaceholderColor);
  document.documentElement.style.setProperty('--sbh', chatConfig.sendButtonHoverColor);
  document.documentElement.style.setProperty('--fbh', chatConfig.fileButtonHoverColor);

  return (
      <div className="window window-desktop">
        <div className="container" style={{backgroundColor: chatConfig.chatBadgeBackgroundColor}}>
          <div className="header"
               style={{background: `linear-gradient(${chatConfig.headerDegree}deg, ${chatConfig.headerLeftColor},${chatConfig.headerRightColor})`}}>
            <div>
              <div className="agent-profile">
                <div className="circle-image">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="38 38 512 512">
                    <path fill="#454545" fillRule="evenodd" d="M256 42.667A213.333 213.333 0 0 1 469.334 256c0 117.821-95.513 213.334-213.334 213.334c-117.82 0-213.333-95.513-213.333-213.334C42.667 138.18 138.18 42.667 256 42.667m21.334 234.667h-42.667c-52.815 0-98.158 31.987-117.715 77.648c30.944 43.391 81.692 71.685 139.048 71.685s108.104-28.294 139.049-71.688c-19.557-45.658-64.9-77.645-117.715-77.645M256 106.667c-35.346 0-64 28.654-64 64s28.654 64 64 64s64-28.654 64-64s-28.653-64-64-64" />
                  </svg>
                </div>
                <span id="agent-status"></span>
              </div>
              <div style={{flex: '1'}}>
                <div className="partner-name">{chatConfig.title || currentPartner?.name}</div>
                <div className="agent-name">
                  <svg className="wait" width="40" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <circle cx="4" cy="12" r="0" fill={chatConfig.waitingAgentAnimationColor}>
                      <animate fill="freeze" attributeName="r" begin="0;SVGUppsBdVN.end" calcMode="spline" dur="0.5s"
                               keySplines=".36,.6,.31,1" values="0;3"/>
                      <animate fill="freeze" attributeName="cx" begin="SVGqCgsydxJ.end" calcMode="spline" dur="0.5s"
                               keySplines=".36,.6,.31,1" values="4;12"/>
                      <animate fill="freeze" attributeName="cx" begin="SVG3PwDNd6F.end" calcMode="spline" dur="0.5s"
                               keySplines=".36,.6,.31,1" values="12;20"/>
                      <animate id="SVG3V8yEdYE" fill="freeze" attributeName="r" begin="SVG6wCQhd9Q.end"
                               calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="3;0"/>
                      <animate id="SVGUppsBdVN" fill="freeze" attributeName="cx" begin="SVG3V8yEdYE.end" dur="0.001s"
                               values="20;4"/>
                    </circle>
                    <circle cx="4" cy="12" r="3" fill={chatConfig.waitingAgentAnimationColor}>
                      <animate fill="freeze" attributeName="cx" begin="0;SVGUppsBdVN.end" calcMode="spline" dur="0.5s"
                               keySplines=".36,.6,.31,1" values="4;12"/>
                      <animate fill="freeze" attributeName="cx" begin="SVGqCgsydxJ.end" calcMode="spline" dur="0.5s"
                               keySplines=".36,.6,.31,1" values="12;20"/>
                      <animate id="SVG4PgJdbds" fill="freeze" attributeName="r" begin="SVG3PwDNd6F.end"
                               calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="3;0"/>
                      <animate id="SVG6wCQhd9Q" fill="freeze" attributeName="cx" begin="SVG4PgJdbds.end" dur="0.001s"
                               values="20;4"/>
                      <animate fill="freeze" attributeName="r" begin="SVG6wCQhd9Q.end" calcMode="spline" dur="0.5s"
                               keySplines=".36,.6,.31,1" values="0;3"/>
                    </circle>
                    <circle cx="12" cy="12" r="3" fill={chatConfig.waitingAgentAnimationColor}>
                      <animate fill="freeze" attributeName="cx" begin="0;SVGUppsBdVN.end" calcMode="spline" dur="0.5s"
                               keySplines=".36,.6,.31,1" values="12;20"/>
                      <animate id="SVG38aCdcdI" fill="freeze" attributeName="r" begin="SVGqCgsydxJ.end"
                               calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="3;0"/>
                      <animate id="SVG3PwDNd6F" fill="freeze" attributeName="cx" begin="SVG38aCdcdI.end" dur="0.001s"
                               values="20;4"/>
                      <animate fill="freeze" attributeName="r" begin="SVG3PwDNd6F.end" calcMode="spline" dur="0.5s"
                               keySplines=".36,.6,.31,1" values="0;3"/>
                      <animate fill="freeze" attributeName="cx" begin="SVG6wCQhd9Q.end" calcMode="spline" dur="0.5s"
                               keySplines=".36,.6,.31,1" values="4;12"/>
                    </circle>
                    <circle cx="20" cy="12" r="3" fill={chatConfig.waitingAgentAnimationColor}>
                      <animate id="SVGwaWzveSq" fill="freeze" attributeName="r" begin="0;SVGUppsBdVN.end"
                               calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="3;0"/>
                      <animate id="SVGqCgsydxJ" fill="freeze" attributeName="cx" begin="SVGwaWzveSq.end" dur="0.001s"
                               values="20;4"/>
                      <animate fill="freeze" attributeName="r" begin="SVGqCgsydxJ.end" calcMode="spline" dur="0.5s"
                               keySplines=".36,.6,.31,1" values="0;3"/>
                      <animate fill="freeze" attributeName="cx" begin="SVG3PwDNd6F.end" calcMode="spline" dur="0.5s"
                               keySplines=".36,.6,.31,1" values="4;12"/>
                      <animate fill="freeze" attributeName="cx" begin="SVG6wCQhd9Q.end" calcMode="spline" dur="0.5s"
                               keySplines=".36,.6,.31,1" values="12;20"/>
                    </circle>
                  </svg>
                </div>
              </div>
              <button id="chat-end"><svg viewBox="0 0 80.504 70.321" xmlns="http://www.w3.org/2000/svg">
                <g transform="translate(-155.512 -2297.704)">
                  <g><path d="M196.092,2297.7h0c-20.418,0-36.964,13.489-36.964,30.138a25.262,25.262,0,0,0,2.555,11.034l56.654-35.107A42.516,42.516,0,0,0,196.092,2297.7Z"></path></g>
                  <g><path d="M233.056,2327.841a26.864,26.864,0,0,0-8.347-19.074l11.307-7.007-1.453-2.346-11.97,7.418-.009-.008-58.426,36.206.007.009-8.653,5.362,1.454,2.346,8.924-5.53c6.692,7.72,17.721,12.763,30.2,12.763a63.118,63.118,0,0,0,9.918-.773l19.834,10.818L218.63,2350.9C227.283,2345.378,233.056,2337.492,233.056,2327.841Z"></path></g>
                </g>
              </svg></button>
            </div>
          </div>
          <div className="messages">
            <div className="messages-container">
              <div id="i2" className="message message-right">
                <div>
                  <div className="message-container" style={{backgroundColor: chatConfig.messagesBackgroundColors.client, color: chatConfig.visitorTextColor}}>
                    <div className="text">I have a question about your pricing plans.</div>
                  </div>
                  <div className="info">
                    <span style={{color: chatConfig.botTextColor}}>10:30 AM</span>
                  </div>
                </div>
              </div>
              <div id="i4" className="message message-left">
                <div>
                  <div className="message-container" style={{backgroundColor: chatConfig.messagesBackgroundColors.our, color: chatConfig.agentTextColor}}>
                    <div className="text">Of course! I'd be happy to help.\nCan you tell me a bit about your needs?</div>
                  </div>
                  <div className="info">
                    <span style={{color: chatConfig.botTextColor}}>10:31 AM</span>
                  </div>
                </div>
              </div>
            </div>
            <div id="typing" className="message message-left" style={{marginTop: 'auto'}}>
              <div className="message-container" style={{backgroundColor: chatConfig.messagesBackgroundColors.our}}>
                <div id="typing-animation">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <circle cx="4" cy="12" r="3" fill={chatConfig.typingAnimationColor}>
                      <animate id="SVGKiXXedfO" attributeName="cy" begin="0;SVGgLulOGrw.end+0.25s" calcMode="spline" dur="0.6s" keySplines=".33,.66,.66,1;.33,0,.66,.33" values="12;6;12" />
                    </circle>
                    <circle cx="12" cy="12" r="3" fill={chatConfig.typingAnimationColor}>
                      <animate attributeName="cy" begin="SVGKiXXedfO.begin+0.1s" calcMode="spline" dur="0.6s" keySplines=".33,.66,.66,1;.33,0,.66,.33" values="12;6;12" />
                    </circle>
                    <circle cx="20" cy="12" r="3" fill={chatConfig.typingAnimationColor}>
                      <animate id="SVGgLulOGrw" attributeName="cy" begin="SVGKiXXedfO.begin+0.2s" calcMode="spline" dur="0.6s" keySplines=".33,.66,.66,1;.33,0,.66,.33" values="12;6;12" />
                    </circle>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div style={{borderTop: `1px solid ${chatConfig.textareaBorderColor}`}} className="messaging">
            <div>
              <div style={{border: `1px solid ${chatConfig.textareaBorderColor}`}} className="textarea-container"><textarea style={{color: chatConfig.typingTextColor}} placeholder="Type your message…" rows="1"></textarea></div>
              <button style={{backgroundColor: chatConfig.fileButtonBackgroundColor}} id="file-select" type="button">
                <span className="count"></span>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path fill="none" stroke={chatConfig.fileButtonIconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        d="M21 10.5l-8.6 8.6a5 5 0 01-7.1-7.1L14 3.3a3.5 3.5 0 015 5L10.4 17a2 2 0 01-2.8-2.8l8.1-8.1"></path>
                </svg>
              </button>
              <button id="message-create" style={{backgroundColor: chatConfig.sendButtonBackgroundColor}} type="button">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path fill="none" stroke={chatConfig.sendButtonIconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        d="M22 2L11 13"></path>
                  <path fill="none" stroke={chatConfig.sendButtonIconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        d="M22 2l-7 20-4-9-9-4 20-7z"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div style={{display: 'flex', gap: '5px'}}>
          <button className="" id="window-toggle" style={{
            width: '64px',
            height: '64px',
            borderRadius: chatConfig.widgetType === 'bar' ? '10px' : '50%',
            background: gradients[chatConfig.widgetGradientType](chatConfig.widgetDegree, chatConfig.widgetLeftColor, chatConfig.widgetRightColor)
          }}>
            <svg id="opened" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path fill={chatConfig.widgetIconColor} d="M6.7 9.3a1 1 0 011.4 0L12 13.2l3.9-3.9a1 1 0 111.4 1.4l-4.6 4.6a1 1 0 01-1.4 0l-4.6-4.6a1 1 0 010-1.4z"></path>
            </svg>
          </button>
          <button id="window-toggle" style={{
            width: '64px',
            height: '64px',
            borderRadius: chatConfig.widgetType === 'bar' ? '10px' : '50%',
            background: gradients[chatConfig.widgetGradientType](chatConfig.widgetDegree, chatConfig.widgetLeftColor, chatConfig.widgetRightColor),
          }}>
            <svg id="closed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <g fill="none" stroke={chatConfig.widgetIconColor} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                <path d="M2 10.5c0-.77.013-1.523.04-2.25c.083-2.373.125-3.56 1.09-4.533c.965-.972 2.186-1.024 4.626-1.129A100 100 0 0 1 12 2.5c1.48 0 2.905.03 4.244.088c2.44.105 3.66.157 4.626 1.13c.965.972 1.007 2.159 1.09 4.532a64 64 0 0 1 0 4.5c-.083 2.373-.125 3.56-1.09 4.533c-.965.972-2.186 1.024-4.626 1.129q-1.102.047-2.275.07c-.74.014-1.111.02-1.437.145s-.6.358-1.148.828l-2.179 1.87A.73.73 0 0 1 8 20.77v-2.348l-.244-.01c-2.44-.105-3.66-.157-4.626-1.13c-.965-.972-1.007-2.159-1.09-4.532A64 64 0 0 1 2 10.5" />
                <path d="M12.126 10.5H12m-3.876 0H8m8.125 0H16m-3.75 0a.25.25 0 1 1-.5 0a.25.25 0 0 1 .5 0m-4 0a.25.25 0 1 1-.5 0a.25.25 0 0 1 .5 0m8 0a.25.25 0 1 1-.5 0a.25.25 0 0 1 .5 0" />
              </g>
            </svg>
          </button>
        </div>
      </div>
  )
}

PreChatForm.defaultProps = {
  chatConfig: {}
}